import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { NAME_SPACE } from 'i18n';
import { AsyncInputAutocomplete, Form, Input, Switch } from '@engloba-tech/englobity';
import { experiences } from 'services';
import { useFormQRCodeStyles } from './formQRCode.styles';
import { multilanguageExperiences } from 'services';

export function FormQRCode({ formRef, onSubmit, errors }) {
  const { t } = useTranslation(NAME_SPACE.QR_CODES);
  const classes = useFormQRCodeStyles();
  const [inputs, setInputs] = useState({});
  const [multilanguageExperience, setMultilanguageExperience] = useState(false);

  function handleSubmit() {
    if (inputs.productId) {
      onSubmit(inputs);
    }
  }

  const handleChange =
    fieldName =>
    ({ target }) =>
      setInputs(prevInputs => ({ ...prevInputs, [fieldName]: target.value }));

  function handleExperienceAutocomplete(element) {
    setInputs(prevFilters => ({
      ...prevFilters,
      productId: element?.id,
      product: element?.name
    }));
  }

  function handleMultiLanguageSwitchChange() {
    setMultilanguageExperience(prev => !prev);
    setInputs(prevFilters => ({
      ...prevFilters,
      productId: '',
      product: ''
    }));
  }

  return (
    <Form className={classes.form} elementRef={formRef} onSubmit={handleSubmit} autoComplete="off" errors={errors}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography component="div" variant="body2">
            {t('create.description')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Tooltip title={t('create.checkMultilanguageTooltip')} placement={'bottom'}>
            <div className={classes.tooltipWrapper}>
              <Switch
                label={multilanguageExperience ? t('create.checkMultilanguage') : t('create.checkSingle')}
                checked={multilanguageExperience || false}
                onChange={handleMultiLanguageSwitchChange}
              />
            </div>
          </Tooltip>
        </Grid>
        <Grid item xs={12}>
          <AsyncInputAutocomplete
            onChange={(e, element) => handleExperienceAutocomplete(element)}
            label={t('create.properties.product')}
            required
            variant="outlined"
            icon={<SearchIcon />}
            value={inputs.productId ? { name: inputs.product, id: inputs.productId } : null}
            defaultInputValue={inputs.product || ''}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={option => option.name}
            requestAction={
              multilanguageExperience ? multilanguageExperiences.getUsingQueryFilter : experiences.getUsingQueryFilter
            }
            validators={['required']}
            errorMessages={[t('validations.required')]}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            required
            name={t('create.properties.name')}
            label={t('create.properties.name')}
            variant="outlined"
            value={inputs.name || ''}
            onChange={handleChange('name')}
            inputProps={{ 'aria-label': t('create.properties.name') }}
            validators={['required', 'maxStringLength:255']}
            errorMessages={[t('validations.required'), t('common:validations.maxStringLength', { length: 255 })]}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

FormQRCode.propTypes = {
  formRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object
};
